
// Helper Function to get Error message

export const setRpErrMsg = (temp_state) => {
    temp_state.errMsg = "";
    if (temp_state.mainPoints === "") {
        temp_state.errMsg = "Please provide details";
    }

    temp_state["isRewriteParagraphBtnDisabled"] = temp_state.errMsg !== "";
};

export const rewriteParagraphFormBody = ({ propState, userDetails }) => {
    const bodyobj = {
        order_id: propState["order_id"],
        prompt_type: "rewrite_paragraph",
        form_schema: {},
        name: userDetails?.name || "",
        email: userDetails?.email || "",
    };

    // Tone
    if (propState["tone"]["selectedItem"]) {
        bodyobj.form_schema["tone"] = propState["tone"]["selectedItem"];
    }

    // Main Points/Details
    bodyobj.form_schema["mainPoints"] = propState["mainPoints"];
   
    return bodyobj;
};

export const repopulate =(temp_state,data)=>{

    temp_state.order_id=data.order_id
    let form_schema=data?.form_schema

    if(form_schema?.tone){
        temp_state.tone.title=form_schema?.tone
        temp_state.tone.selectedItem=form_schema?.tone
    }
    if(form_schema?.mainPoints){
        temp_state.mainPoints=form_schema?.mainPoints
    }
    temp_state.pageType="Generated Section"
    temp_state.repopulate=true
    temp_state.paragraphGenerated= rpFormat(data?.descriptions)
}


// Helper fuction to check action response

export const checkActRes=(res, action)=> {
    let descObj = res?.data[action.payload.descInd];
    if (res?.status !== "success") {
        return false;
    }
    if (res?.data.length === 0) {
        return false;
    }
    if (descObj["gen_id"] !== action.payload.gen_id) {
        return false;
    }
    Object.keys(action.payload.actionInfo).forEach((actKey) => {
        if (descObj[actKey] !== action.payload.actionInfo[actKey]) {
            return false;
        }
    });

    return true;
}

// Helper function for formatting response

export const rpFormat = (responseArr) => {
    return responseArr.map((resObj, i) => {
        // reducer description schema
        return {
            status: "Just now",
            description_generated: resObj?.description_generated || "",
            editedDesc: resObj?.description_generated || "",
            isEditing: false,
            isEdited: resObj?.is_edited || false,
            like_status: resObj?.like_status,
            generated_at: resObj?.updatedAt || "",
            gen_id: resObj.gen_id,
            rewrite_count:resObj?.rewrite_count || 0
        };
    });
}
